type Amounts = {estimated_usd?:unknown;estimated_cdf?:unknown;declared_usd?:unknown;declared_cdf?:unknown};

// PostgreSQL decimals arrive as text. Do not round them through JavaScript Number
// or convert currencies: a declaration can have two independent taxable bases.
export function declarationAmount(value:unknown,currency:string):string {
 if(typeof value!=='string'&&typeof value!=='number')return 'Non renseigné';
 const match=String(value).match(/^(\d+)(?:\.(\d{1,4}))?$/);
 if(!match)return 'Non renseigné';
 const whole=match[1].replace(/^0+(?=\d)/,'').replace(/\B(?=(\d{3})+(?!\d))/g,'\u202f');
 const fraction=(match[2]||'').replace(/0+$/,'').padEnd(2,'0');
 return `${whole},${fraction} ${currency}`;
}

export default function DeclarationAmounts({row}:{row:Amounts}) {
 const currencies=(['USD','CDF'] as const).filter(currency=>{
  const suffix=currency.toLowerCase();
  return row[`estimated_${suffix}` as keyof Amounts]!=null||row[`declared_${suffix}` as keyof Amounts]!=null;
 });
 return <dl className="dossier-amounts">
  {([['estimated','Montant estimé par la plateforme'],['declared','Montant déclaré']] as const).map(([kind,label])=><div key={kind}>
   <dt>{label} :</dt><dd>{currencies.length?currencies.map(currency=>{
    const formatted=declarationAmount(row[`${kind}_${currency.toLowerCase()}` as keyof Amounts],currency);
    return <span key={currency}>{formatted==='Non renseigné'?`${formatted} (${currency})`:formatted}</span>;
   }):'Non renseigné'}</dd>
  </div>)}
 </dl>;
}
